// Chat widget specific events for Vue-React communication
export enum ChatEvents {
  UpdateTheme = 'chat:updateTheme',
  UpdateRoomId = 'chat:updateRoomId',
  UpdateTabs = 'chat:updateTabs',
  UpdateSelectedTab = 'chat:updateSelectedTab',
  UpdateBlacklistedEmojis = 'chat:updateBlacklistedEmojis',
  UpdateCurrentUser = 'chat:updateCurrentUser',
  UpdatePermissions = 'chat:updatePermissions',
  UpdateCanChat = 'chat:updateCanChat',
  UpdateGifsEnabled = 'chat:updateGifsEnabled',
  UpdateQnaChannelId = 'chat:updateQnaChannelId',
  UpdateThreadChatDisabled = 'chat:updateThreadChatDisabled',
  WidgetMounted = 'chat:widgetMounted',
  WidgetUnmounted = 'chat:widgetUnmounted',
  MessageSent = 'chat:messageSent',
  TabChanged = 'chat:tabChanged',
  DirectChatOpened = 'chat:directChatOpened',
  SocketAvailable = 'chat:socketAvailable',
  LinkClicked = 'chat:linkClicked'
}

export interface ChatEventData {
  widgetId?: string;
  [key: string]: any;
}
